/**
 *
 * @param {API.Poll} poll
 * @return {string}
 */
export const getPollStatus = (poll) => {
    if (poll.startedAt && !poll.settings?.nextStartAt) {
        if (poll.closedAt && !poll.settings?.nextStopAt) {
            return 'offline';
        }
        if (poll.settings?.nextStopAt) {
            return 'ending';
        } else {
            return 'online';
        }
    } else if (poll.settings?.nextStartAt) {
        return 'starting';
    } else {
        return 'draft';
    }
};
